import { MenuItem } from 'primeng/api';

export const SuperAdminMenu: MenuItem[] = [
  {
    label: 'Home',
    icon: 'pi pi-home',
    routerLink: ['/home'],
  },
  {
    label: 'Dashboards',
    icon: 'pi pi-th-large',
    routerLink: ['/dashboards'],
    items: [
      {
        label: 'Track Products',
        icon: 'pi pi-truck',
        routerLink: ['/dashboards/track-products'],
        slugs: ['tracking-dashboard', 'recall-dashboard', 'heatmaps-dashboard'],
      },
      {
        label: 'Scan Statistics',
        icon: 'pi pi-chart-bar',
        routerLink: ['/dashboards/scan-statistics'],
        slugs: ['tracking-dashboard', 'recall-dashboard', 'heatmaps-dashboard'],
      },
      {
        label: 'Product Expiration',
        icon: 'pi pi-calendar-clock',
        routerLink: ['/dashboards/product-expiration'],
        slugs: ['tracking-dashboard', 'recall-dashboard', 'heatmaps-dashboard'],
      },
      {
        label: 'Page Views',
        icon: '',
        routerLink: ['/dashboards/page-views'],
        slugs: ['tracking-dashboard', 'recall-dashboard', 'heatmaps-dashboard'],
      },
      {
        label: 'Traceability Ledger',
        icon: 'pi pi-shield',
        routerLink: ['/dashboards/traceability'],
        slugs: ['tracking-dashboard'],
      },
    ],
  },
  {
    label: 'Organizations',
    icon: 'pi pi-building-columns',
    routerLink: ['/organizations/list'],
  },
  {
    label: 'Demo Requests',
    icon: 'pi pi-info-circle',
    routerLink: ['/organizations/demo-requests'],
  },
  {
    label: 'A/C QR Requests',
    icon: 'pi pi-qrcode',
    routerLink: ['/anti-counterfeit-requests/list'],
  },
  {
    label: 'Admin Users',
    icon: 'pi pi-user-plus',
    routerLink: ['/users/admin'],
  },
];
export const ProfileMenu: MenuItem[] = [
  {
    label: 'Settings',
    icon: 'pi pi-cog',
    routerLink: ['/settings'],
  },
];

export const OrganizationMenu: MenuItem[] = [
  {
    label: 'Home',
    icon: 'pi pi-home',
    routerLink: ['/home'],
    slugs: ['tracking-dashboard', 'recall-dashboard', 'heatmaps-dashboard'],
  },
  {
    label: 'Dashboards',
    icon: 'pi pi-th-large',
    slugs: ['show-menu-dashboard'],
    routerLink: ['/dashboards'],
    items: [
      {
        label: 'Track Products',
        icon: 'pi pi-truck',
        routerLink: ['/dashboards/track-products'],
        slugs: ['tracking-dashboard', 'recall-dashboard', 'heatmaps-dashboard'],
      },
      {
        label: 'Scan Statistics',
        icon: 'pi pi-chart-bar',
        routerLink: ['/dashboards/scan-statistics'],
        slugs: ['tracking-dashboard', 'recall-dashboard', 'heatmaps-dashboard'],
      },
      {
        label: 'Product Expiration',
        icon: 'pi pi-calendar-clock',
        routerLink: ['/dashboards/product-expiration'],
        slugs: ['tracking-dashboard', 'recall-dashboard', 'heatmaps-dashboard'],
      },
      {
        label: 'Page Views',
        icon: '',
        routerLink: ['/dashboards/page-views'],
        slugs: ['tracking-dashboard', 'recall-dashboard', 'heatmaps-dashboard'],
      },
      {
        label: 'Traceability Ledger',
        icon: 'pi pi-shield',
        routerLink: ['/dashboards/traceability'],
        slugs: ['tracking-dashboard'],
      },
    ],
  },
  {
    label: 'Users',
    icon: 'pi pi-users',
    routerLink: ['/users/list'],
    slugs: ['show-menu-user'],
  },
  {
    label: 'Groups & Vendors',
    icon: 'pi pi-warehouse',
    routerLink: ['/groups/list'],
    slugs: ['show-menu-vendor'],
  },
  {
    label: 'Farmers',
    icon: 'pi pi-box',
    routerLink: ['/resources/list'],
    slugs: ['show-menu-resources'],
  },
  {
    label: 'QR Data Capture',
    icon: 'pi pi-qrcode',
    routerLink: ['/products/scan-qr'],
    slugs: ['scan-product-data'],
  },
  {
    label: 'Product Management',
    icon: 'pi pi-shopping-bag',
    slugs: ['show-menu-product'],
    routerLink: ['/products'],
    items: [
      {
        label: 'Products',
        icon: 'pi pi-shopping-bag',
        routerLink: ['/products/list'],
        slugs: ['list-product'],
      },
      {
        label: 'Product Item Data',
        icon: 'pi pi-database',
        routerLink: ['/products/data'],
        slugs: ['list-product-data'],
      },
    ],
  },
  {
    label: 'Public Experiences',
    icon: 'pi pi-mobile',
    slugs: ['show-menu-product'],
    routerLink: ['/public-experiences/list'],
  },
  {
    label: 'QR Codes',
    icon: 'pi pi-qrcode',
    routerLink: ['/qr/qr-codes/list'],
    slugs: ['show-menu-qr-order'],
  },

  {
    label: 'Recall Management',
    icon: 'pi pi-chevron-circle-left',
    slugs: ['show-menu-recall-product'],
    routerLink: ['/recall-management'],
    items: [
      {
        label: 'Recall Dashboard',
        icon: 'pi pi-directions-alt',
        routerLink: ['/recall-management/dashboard'],
        slugs: ['recall-dashboard'],
      },
      {
        label: 'Recall List',
        icon: 'pi pi-chevron-circle-left',
        routerLink: ['/recall-management/list'],
        slugs: ['recall-dashboard'],
      },
      {
        label: 'Recall Request List',
        icon: 'pi pi-directions-alt',
        routerLink: ['/recall-management/request-list'],
        slugs: ['recall-dashboard'],
      },
    ],
  },
  {
    label: 'Subscription',
    icon: 'pi pi-credit-card',
    routerLink: ['/subscription/plans'],
    slugs: ['show-menu-subscription'],
  },
  {
    label: 'Reporting',
    icon: 'pi pi-address-book',
    slugs: ['show-menu-reporting'],
    routerLink: ['/reports'],
    items: [
      {
        label: 'Customized Reports',
        routerLink: ['/reports/customized/list'],
        slugs: ['show-menu-reporting'],
      },
      {
        label: 'Static Reports',
        routerLink: ['/reports/static/list'],
        slugs: ['show-menu-reporting'],
      },
    ],
  },
];

export const HeaderMenu: MenuItem[] = [
  {
    label: 'Profile',
    icon: 'pi pi-user',
    routerLink: ['/settings/profile-security'],
  },
  {
    separator: true,
  },
  {
    label: 'Logout',
    icon: 'pi pi-sign-out',
    command: () => {
      localStorage.clear();
      window.location.href = '/login';
    },
  },
];
